import { render } from "./TriageAssessment.vue?vue&type=template&id=4fea50ca&scoped=true"
import script from "./TriageAssessment.vue?vue&type=script&lang=js"
export * from "./TriageAssessment.vue?vue&type=script&lang=js"

import "./TriageAssessment.vue?vue&type=style&index=0&id=4fea50ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fea50ca"]])

export default __exports__